// Service Worker Registration a Update Manager

let registration = null;
let updateCheckInterval = null;

// Registrácia Service Worker
export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL || ''}/service-worker.js`;
      
      navigator.serviceWorker
        .register(swUrl)
        .then((reg) => {
          registration = reg;
          console.log('✅ Service Worker registered:', swUrl);
          
          // Kontrola aktualizácií každých 5 minút
          updateCheckInterval = setInterval(() => {
            checkForUpdates(reg);
          }, 5 * 60 * 1000); // 5 minút
          
          // Kontrola pri každom focus na okno
          window.addEventListener('focus', () => {
            checkForUpdates(reg);
          });
          
          // Spracovanie update-e
          reg.addEventListener('updatefound', () => {
            console.log('🔄 New Service Worker found, updating...');
            const newWorker = reg.installing;
            
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  // Nová verzia je pripravená
                  console.log('✨ New version available!');
                  notifyUpdateAvailable(() => {
                    // Používateľ chce aktualizovať
                    newWorker.postMessage({ type: 'SKIP_WAITING' });
                    window.location.reload();
                  });
                }
              });
            }
          });
        })
        .catch((error) => {
          console.error('❌ Service Worker registration failed:', error);
        });
    });
  }
}

// Kontrola aktualizácií
async function checkForUpdates(reg) {
  try {
    // Skús update Service Worker
    await reg.update();
    
    // Skontroluj, či sa zmenili súbory
    if (reg.waiting) {
      console.log('✨ Update available!');
      notifyUpdateAvailable(() => {
        reg.waiting.postMessage({ type: 'SKIP_WAITING' });
        window.location.reload();
      });
    }
  } catch (error) {
    console.error('Update check failed:', error);
  }
}

// Notifikácia o dostupnej aktualizácii
function notifyUpdateAvailable(onUpdate) {
  console.log('✨ Nová verzia aplikácie je dostupná!');
  
  // Pošli event do React app pre toast notifikáciu
  const updateEvent = new CustomEvent('app-update-available', {
    detail: { onUpdate }
  });
  window.dispatchEvent(updateEvent);
  
  // Automatická aktualizácia po 2 sekundách (dáva čas na toast notifikáciu)
  setTimeout(() => {
    console.log('🔄 Automaticky aktualizujem aplikáciu...');
    onUpdate();
  }, 2000);
}

// Automatická aktualizácia (bez potvrdenia)
export function autoUpdate() {
  if (registration && registration.waiting) {
    registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    window.location.reload();
  }
}

// Manuálna kontrola aktualizácií
export async function checkUpdate() {
  if (registration) {
    await checkForUpdates(registration);
    return registration.waiting !== null;
  }
  return false;
}

// Zrušenie registrácie
export function unregister() {
  if (registration) {
    registration.unregister().then(() => {
      console.log('Service Worker unregistered');
    });
  }
  
  if (updateCheckInterval) {
    clearInterval(updateCheckInterval);
  }
}

